import { Combo, SelectedComboItem } from 'core/domains';
import { useCommand } from 'core/use-cases/utilities';

import { actions } from '../slice';

/**
 * Exports combo dispatch commands.
 *
 */
export function useComboCommand() {
  const { dispatchCommand } = useCommand();

  /**
   * Clean up page from store to avoid memory leaks
   *
   */
  function cleanCombo() {
    dispatchCommand(actions.comboCleanUp());
  }

  /**
   * Gets combo
   *
   */
  function getCombo() {
    dispatchCommand(actions.comboFetch.request());
  }

  /**
   * Add combo
   *
   */
  function postCombo(payload: Combo['data']) {
    dispatchCommand(actions.comboPost.request(payload));
  }

  /**
   * Update combo
   *
   */
  function updateCombo(comboCode: Combo['data']['comboCode']) {
    dispatchCommand(actions.comboUpdate(comboCode));
  }

  /**
   * Update combo item
   *
   */
  function updateComboItem(payload: SelectedComboItem) {
    dispatchCommand(actions.comboItemUpdate(payload));
  }

  return {
    cleanCombo,
    getCombo,
    postCombo,
    updateCombo,
    updateComboItem,
  };
}
